<template>
  <div
    class="container upcoming-content home-p-color"
    style="padding-bottom: 65px;"
  >
    <div class="up-cont-top">
      <img
        class="up-cont-top-logo"
        src="/official/static/img/events/upcoming/logo_ppwc.svg"
      >
      <div class="up-cont-top-div">
        <h2 class="home-color">
          {{ $t('ppwc.p73') }}
        </h2>
        <h2 class="home-color">
          {{ $t('ppwc.p72') }}
        </h2>
        <p><strong>{{ $t('ppwc.p74') }}</strong> {{ $t('ppwc.p104') }}</p>
        <p><strong>{{ $t('ppwc.p75') }}</strong> {{ $t('ppwc.p105') }}</p>
      </div>
    </div>

    <el-divider />

    <p class="p-margin-bottom">
      {{ $t('ppwc.p76') }}
    </p>
    <p class="p-margin-bottom">
      {{ $t('ppwc.p77') }}
    </p>
    <p class="p-margin-bottom">
      {{ $t('ppwc.p78') }}
    </p>
<!--    <a-->
<!--      class="up-activate"-->
<!--      target="_blank"-->
<!--      href="https://thelivepoker.com//ppwc"-->
<!--    >-->
<!--      <p>{{ $t('ppwc.p2') }}</p>-->
<!--    </a>-->

    <h2 class="home-color">
      {{ $t('ppwc.p79') }}
    </h2>
    <p class="p-margin-bottom">
      {{ $t('ppwc.p80') }}
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;• {{ $t('ppwc.p81') }}</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;• {{ $t('ppwc.p82') }}</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;• {{ $t('ppwc.p83') }}</p>
    <p class="p-margin-bottom">
      &nbsp;&nbsp;&nbsp;&nbsp;• {{ $t('ppwc.p84') }}
    </p>

    <div
      v-if="show"
      class="pops"
    >
      <div class="dark" />
      <div class="pop">
        <div class="f-dialog">
          <div class="f-title">
            <div class="f-t-title">
              <p>{{ $t('ppwc.p67') }}</p>
            </div>
          </div>
          <div class="f-content">
            <p>{{ $t('ppwc.p69') }}</p>
          </div>
          <div class="f-t-button">
            <div
              class="f-t-cancel"
              @click="show = false"
            >
              <p class="home-color">
                {{ $t('ppwc.p31') }}
              </p>
            </div>
            <div
              class="f-t-confirm"
              @click="toActivate"
            >
              <p>{{ $t('ppwc.p12') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import googleMap from './googleMap.vue';

export default {
  components: {
    // googlMap
  },
  data () {
    return {
      shw: false
    }
  },
  methods: {
    toActivate () {
      this.$router.push({ name: 'upcoming-activate', params: { sep: 1 } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.upcoming-content {
  p {
    font-size: 16px;
    line-height: 24px;
  }
  .p-margin-bottom {
    margin-bottom: 20px;
  }
  .picture {
    width: 460px;
  }
  h2 {
    font-size: 22px;
    margin-top: 38px;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 20px;
    margin: 18px 0px;
    line-height: 26px;
  }
  .map {
    display: block;
    img {
      width: 100%;
    }
  }
  .up-cont-top {
    .up-cont-top-logo {
      display: inline-block;
      vertical-align: top;
      margin-top: -6px;
      width: 146px;
    }
    .up-cont-top-div {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      h2 {
        margin: 0px;
        font-size: 28px;
        margin-bottom: 10px;
      }
      p {
        font-size: 18px;
        line-height: 32px;
        // font-weight: bold;
      }
    }
  }
  .el-divider--horizontal {
    margin: 22px 0px;
  }
  .up-activate {
    cursor: pointer;
    margin-bottom: 36px;
    width: 240px;
    height: 38px;
    display: block;
    background: url('/official/static/img/events/upcoming/button.png') no-repeat center center;
    background-size: 100%;
    p {
      color: #fff;
      text-align: center;
      line-height: 32px;
      font-size: 18px;
    }
  }
  .up-activate {
    -o-transition: all cubic-bezier(.165,.84,.44,1) .3s;
    transition: all cubic-bezier(.165,.84,.44,1) .3s;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
  .up-activate:hover {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }

  .pops {
    position: fixed;
    top: 20%;
    left: 50%;
    width: 660px;
    margin-left: -330px;
    z-index: 3000;
    .dark {
      background-color: #000000;
      filter: Alpha(opacity=60);
      -moz-opacity: 0.6;
      opacity: 0.6;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .f-dialog {
      width: 100%;
      height: auto;
      z-index: 3500;
      position: relative;
      background-color: #fff;
      padding-bottom: 40px;
      border-radius: 4px;
      .f-t-button {
        margin-top: 30px;
        text-align: center;
        .f-t-cancel {
          position: relative;
          height: 44px;
          width: 200px;
          margin-right: 10px;
          // background-image: url("/official/static/img/dialog/button.png");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          border: 1px solid #1f9d56;
          border-radius: 4px;
          display: inline-block;
          cursor: pointer;
          p {
            line-height: 44px;
            font-size: 26px;
            text-align: center;
          }
        }
        .f-t-confirm {
          position: relative;
          height: 44px;
          width: 200px;
          margin-left: 10px;
          // background-image: url("/official/static/img/dialog/button.png");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          background-color: #1f9d56;
          border-radius: 4px;
          display: inline-block;
          cursor: pointer;
          p {
            color: #fff;
            line-height: 44px;
            font-size: 26px;
            text-align: center;
          }
        }
      }
      .f-title {
        width: 100%;
        height: 120px;
        position: relative;
        .f-t-title {
          height: 140px;
          width: 100%;
          display: inline-block;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            font-size: 60px;
            color: #1f9d56;
            font-weight: bold;
          }
        }
      }
      .f-content {
        width: 100%;
        p {
          padding: 0 30px;
          font-size: 24px;
          line-height: 32px;
          color: #727272;
        }
      }
    }
  }
}
</style>
